<template>
  <Home />
</template>

<script>
import Home from '@/views/Home';
import { useEnvProps } from '@/stores/envProps';
import { headLinks } from '@/utils/seo/headLinks';
import { headMeta } from '@/utils/seo/headMeta';
import { headScripts } from '@/utils/seo/headScripts';

export default {
  name: 'App',
  components: {
    Home,
  },
  setup() {
    if (import.meta.server) {
      const envPropsStore = useEnvProps();
      const envProps = envPropsStore.envProps;
      useHead({
        title: envProps?.meta?.tags?.title,
        link: headLinks(envProps),
        meta: headMeta(envProps),
        script: headScripts(envProps),
      });
    }
  },
  async mounted() {
    // Auto-tagging
    const { ExperimentationTags } = await import('@vue-util/experimentation');
    await ExperimentationTags.fireAdobeTags();
  },
};
</script>

<style lang="scss"></style>
